import { cloneElement } from 'react';
import { Facebook, Github, Linkedin, Twitter } from 'styled-icons/fa-brands';
import Image from 'next/image';
import Link from 'next/link';
import MaxWidth from '@/components/max-width';
import { Grid, Card, Paragraph, Title, SubTitle } from '@bidalihq/ui';
import tw from 'tailwind-styled-components';

import { gradients } from '@/themes';
import funds from '@/data/funds.json';
import investors from '@/data/investors.json';
import Section from '@/components/section';

const Description = tw(SubTitle)`
  text-2xl
  md:text-2xl
  lg:text-2xl
  xl:text-2xl
  text-center
  mb-16
`;

const Member = tw(Card)`
  h-full
  flex
  flex-col
  items-center
  text-center
`;

const HeadshotContainer = tw.div`
  rounded-full
  overflow-hidden
  aspect-square
  mx-auto
  mb-4
`;

const Headshot = tw(Image)`
  grayscale
`;

const Name = tw.h2`
  text-brand-primary
  text-xl
  font-normal
`;

const Role = tw.p`
  text-typography-subtle
  text-sm
  font-normal
  mt-0
`;

const Bio = tw(Paragraph)`
  my-4
`;

const SocialLinks = tw.ul`
  items-center
  flex
  list-none
  justify-center
  p-0
  my-4
  gap-4
`;

const SocialLink = tw(Link)`
  cursor-pointer
  inline-block
  no-underline
  scale-100
  text-typography-subtle/50
  transition-all

  hover:scale-110
  hover:text-typography
`;

const FundLogo = tw.img`
  h-12
  w-auto
  grayscale

  md:h-14
  lg:h-16
`;

const Investors = () => {
  const icons = {
    facebook: <Facebook />,
    github: <Github />,
    linkedin: <Linkedin />,
    twitter: <Twitter />
  };

  return (
    <>
      <Section backgroundColor={`linear-gradient(to bottom, transparent, white), ${gradients.multiColor}`} style={{ clipPath: 'ellipse(100% 100% at bottom center)' }}>
        <Title className="font-black uppercase text-gray-600 tracking-wider mb-24 text-center">Our Backers</Title>
        <Grid columns={[2, 4]} className="gap-8 mb-12">
          {funds.map((fund, index) => (
            <Link href={fund.url} className="col-span-1 flex justify-center" key={index}>
              <FundLogo src={fund.logo} alt={fund.name} />
            </Link>
          ))}
        </Grid>
      </Section>
      <Section style={{ paddingTop: 0 }}>
        <Grid columns={[1, 2, 3, 4]}>
          {investors.map((investor, index) => (
            <Member key={index}>
              <HeadshotContainer>
                <Headshot height={128} src={investor.headshot} width={128} />
              </HeadshotContainer>
              <Name>{investor.name}</Name>
              <Role>{investor.role}</Role>
              {/* <Bio>{investor.bio}</Bio> */}
              <SocialLinks>
                {Object.keys(investor.social).map(network => (
                  <li key={network}>
                    <SocialLink href={investor.social[network]}>
                      {cloneElement(icons[network], { className: 'w-6 h-6' })}
                    </SocialLink>
                  </li>
                ))}
              </SocialLinks>
            </Member>
          ))}
        </Grid>
      </Section>
    </>
  );
};

export default Investors;
